import IconMoreOptions from '@deprecated-ui/common/IconMoreOptions';
import color from '@deprecated-ui/_style/color';
import Menu from '@deprecated-ui/calendar/Menu';
import styled from 'styled-components';

const HorizontalMenu = styled(Menu)`
  border: unset;

  &&& .ant-menu-item {
    margin: unset;
    border: unset;
    border-right: 1px solid ${color.gainsboro};
    border-top: 1px solid ${color.gainsboro};
  }

  &&& .ant-menu-item:nth-last-child(2) {
    border-right: unset;
    width: 40px;
  }

  &&& .ant-menu-item-selected {
    border-bottom: 1px solid ${color.gainsboro};
  }

  // Harcoded index to push the more/dropdown button to the right side of nav
  & .ant-dropdown-trigger {
    order: 8 !important;
  }
`;

const VerticalMenu = styled(Menu)`
  &&& .ant-menu-item {
    margin: 0px;
    height: auto !important;
  }

  .ant-menu-item:nth-last-child(1) {
    border-bottom: unset;
  }

  &&& .ant-menu-item-selected,
  &&& .ant-menu-item-selected:hover {
    background-color: ${color.whisper};
  }
  &&& .ant-menu-item:hover,
  &&& .ant-menu-item-selected p {
    color: ${color.primary};
  }
  &&& .ant-menu-item:active {
    background-color: #ffffff;
  }
`;

const MoreMenu = styled(IconMoreOptions)`
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  ${(props) =>
    props.isDesktopMenu &&
    `width: 38px;
  `}
`;

export { HorizontalMenu, VerticalMenu, MoreMenu };
